<template>
  <div class="user-selector">
  <el-select
    v-model="value"
    filterable
    remote
    value-key="label"
    placeholder="请输入用户名开始搜索"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="onChange"
  >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
    </el-option>
  </el-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { ListData } from '../store/respTypes'
import { UserDataProps } from '../store/user'
import axios from 'axios'
interface ListItem {
  value: string
  label: string
}

export default defineComponent({
  name: 'UserSelector',
  props: {
    modelValue: {
      type: [String, Object],
      required: true
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const loading = ref(false)
    console.log(props.modelValue)
    const value = ref(props.modelValue)
    watch(() => props.modelValue, () => {
      value.value = props.modelValue
    })
    const options = ref<ListItem[]>([])
    const remoteMethod = async (query: string) => { 
      console.log('query', query)
      if (query) {
        loading.value = true
        const { data } = await axios.get<ListData<Required<UserDataProps>[]>>(`/api/users?userName=${query}`)
        loading.value = false
        options.value = data.data.data.map(user => ({ value: user._id, label: user.userName }))
      } else {
        options.value = []
      }
    }
    const onChange = (newValue: string) => {
      console.log('the change', newValue)
      emit('update:modelValue', newValue)
    }
    return {
      loading,
      remoteMethod,
      value,
      options,
      onChange
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
